<template>
  <main id="contents">
    <super-multi-section-list
      :multi-section-title="multiSectionTitle"
      :multi-section-list="multiSectionList">
    </super-multi-section-list>
  </main>
</template>
<script>
  import _ from 'lodash'
  import { buildGnbByUiCode } from '@/common/utils/gnbBuilder'
  import { GNBEventMapper } from '@/common/utils/gnb.fp'
  import { fetchFromEventObject } from '@/common/utils/request.common'
  import { scrollTop } from '@/common/utils/common'
  import SuperMultiSectionList from '@/components/container/SuperMultiSectionList'
  import { EVENT_CLOSE_CATEGORY_LAYOUT } from '@/common/utils/gnb.category'
  import { ON_CLICK_CELL } from '@/common/resources/const'

  export default {
    name: 'SuperMultiSectionIndex',
    components: {
      SuperMultiSectionList
    },
    data () {
      return {
        gnb: null,
        multiSectionTitle: '',
        multiSectionList: [],
        uiCode: ''
      }
    },
    methods: {
      async setData () {
        const eventList = _.get(this.gnb, 'eventlist', [])
        const { onClick, onContent } = GNBEventMapper(eventList)
        this.$events.$emit(ON_CLICK_CELL, onClick)
        const { data } = await fetchFromEventObject(onContent)
        this.gnb = data
        this.multiSectionTitle = _.get(this.gnb, 'note', '멀티섹션')
        this.multiSectionList = _.get(this.gnb, 'multisectionlist', [])
        this.$events.$emit(EVENT_CLOSE_CATEGORY_LAYOUT)
      },
      init () {
        const uiCode = _.get(this.$route, 'params.uiCode', '')
        this.uiCode = uiCode !== '' ? uiCode.toUpperCase() : null
        this.gnb = buildGnbByUiCode(this.uiCode)
        this.setData()
      }
    },
    created () {
      this.uiCode = this.$route.params.uiCode
      this.init()
    },
    mounted () {
      scrollTop()
    }
  }
</script>
